import {ogImage, seoDescription, seoKeywords, seoTitle, structuredData} from "./_seoProvider";

function seoAll(title, description, keywords, structData, image) {
    if(title) seoTitle(title);
    if(description) seoDescription(description);
    if(keywords) seoKeywords(keywords);
    if(structData) structuredData(structData);
    if(image)   ogImage(image);
}
export default seoAll;